import { useRouter } from 'next/router';
import React, { useEffect } from 'react';
import withWalletLoggedIn from '@mainframe/components/common/withWalletLoggedIn';
import { PageHeadTags } from '@mainframe/components/page-head-tags/PageHeadTags';
import { DOCUMENT_IS_DEFINED } from '@mainframe/utils/constants';
import { PageWrapper, PreloaderScreen } from 'ui';

// end user should not be able to see this page
const Index = () => {
  const router = useRouter();

  useEffect(() => {
    if (
      // redirecting after login makes tests flaky, so disable it in e2e test environment
      DOCUMENT_IS_DEFINED &&
      !document.PLAY_TEST
    ) {
      router.push(`/dashboard`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PageWrapper>
      <>
        <PageHeadTags title="Home" />
        <PreloaderScreen />
      </>
    </PageWrapper>
  );
};

export default withWalletLoggedIn(Index);
